var _ = require('lodash');

var createInstanceWithValues = function (prototype, subject) {

    if (!(prototype && _.isFunction(prototype) && subject && _.isObject(subject))) return false;

    return _.forIn(new prototype(), function (value, key, object) { object[key] = subject[key] });
},

    containsArray = function (superset, subset) { return _.difference(subset, superset).length === 0 },
    commaSpace    = ', ',
    isPopulatedArray     = function (unknown) { return _.isArray(unknown) && unknown[0] },
    isEmptyArray         = function (unknown) { return _.isArray(unknown) && unknown.length === 0 },
    redirectPage         = function (url)     { window.location.replace(url) },
    getPathFromUrl       = function (url)     { return url.split(/[?#]/)[0]  },
    getStatusObjFromItem = function (item)    { return _.find(item.MetaData,{ Property: 'Annotation.ApprovalStatus'} ) }

    
    var toNbsp, unNbsp, getBrowserSpecificNonBreakingSpaceCode;

    if(global.isInternetExplorer){

        toNbsp= function (o) { return   _.replace(o, /\x20/g,     String.fromCharCode(0xB7) ) }   // middle dot
        unNbsp= function (o) { var d  = _.replace(o, /\xB7/g,     String.fromCharCode(0x20) );
                               return   _.replace(d, /\&nbsp\;/g, String.fromCharCode(0x20) )  }
        getBrowserSpecificNonBreakingSpaceCode = function () { return 0xB7 } 
    }
    else{
            
        toNbsp= function (o) { return   _.replace(o, /\x20/g,     String.fromCharCode(0xA0) ) }   // non breaking space
        unNbsp= function (o) { var d  = _.replace(o, /\xA0/g,     String.fromCharCode(0x20) );
                               return   _.replace(d, /\&nbsp\;/g, String.fromCharCode(0x20) )  }
        getBrowserSpecificNonBreakingSpaceCode = function () { return 0xA0 } 
    }


var Helpers = {

       makeStateObject: function (rawStateObject) { return _.mapValues(rawStateObject, function (value, key) { return key }) }

    , formatTableNames: function (obj) { return _.mapKeys(obj, function (val, key) {
         return _.camelCase(key) + (_.endsWith(key, 's') ? '' : (_.endsWith(key, 'ry') ? 'ries' : 's')) }) }

    , formatTableName: function (val, key) {
         return _.camelCase(key) + (_.endsWith(key, 's') ? '' : (_.endsWith(key, 'ry') ? 'ries' : 's')) }

    , definitionToString: function (_definition, tableName) {

        var mapped, definition = new _definition();
        if(!_(definition).values().map('name').includes('Primary')){

            mapped = '++id, ' + _(definition).keys().join(commaSpace);
        }else{

            var primaryFieldName = _.findKey(definition, { name : 'Primary' } );
            mapped =  '&' + primaryFieldName + commaSpace + _(definition).keys().without(primaryFieldName).join(commaSpace);
        } 

        console.warn(tableName, mapped);
        return mapped;
    }

    , createInstanceOf: function (prototype) { return function (subject) { return createInstanceWithValues(prototype, subject) } }

    , createInstanceOfWithDefaultValues: function (prototype, defaultValues) {
        return function (subject) {
            var newInstance = createInstanceWithValues(prototype, subject);
            _.assign(newInstance, defaultValues);
            return newInstance;
        }
    }

    , createInstanceWithValues: createInstanceWithValues

    , hasRequiredProperties: function (architype, subject) {
        if (!(architype && (_.isObject(architype) || _.isFunction(architype)) && subject && _.isObject(subject))) return false;
        var template = _.isFunction(architype) ? new architype() : architype,
            templateKeys = _.keys(template);
        return _.intersection(templateKeys, _.keys(subject)).length === templateKeys.length;
    }
    , isPopulatedArray: isPopulatedArray
    , niceNameHere: isPopulatedArray

    , isEmptyArray: isEmptyArray

    , isValidTime: function (val) {
        if (!_.includes(val, ':')) return false;
        var parts = _.split(val, ':');
        if (parts.length !== 2) return false;
        if (!_.inRange(parts[0], 0, 24)) return false;
        var mins = parts[1]
        if (!_.inRange(mins, 0, 60)) return false;
        if (mins < 10) {
           
            if (mins[0] !== '0') return false
            if ((mins == 0) && mins !== '00') return false;
        }
        if (mins.length > 2) return false;
        return true;
    }
    
    , isValidGuid : function (val) {

        var regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return _.isString(val) && !!val.match(regex)
    }



    , makeItemsSelectable: function (arrayOfitems, ko) {
        if (!isPopulatedArray(arrayOfitems)) return arrayOfitems;
        return _.map(arrayOfitems, function (x) { return _.assign(x, { selected: ko.observable() }) });
    },

    isLogicStateEffectivelyTrue: function (logicStateItem) {
        return (!logicStateItem.IsTargetQuestionHidden && logicStateItem.IsTrue) || (logicStateItem.IsTargetQuestionHidden && !(logicStateItem.Term && logicStateItem.Term.ApplyLogicalNot));
    },

    makeFullPageUpdate: function (_fullsize, header, footer, middle, shell, platform, $window, events) {

        return function () {

            var fullsize = _fullsize(),

                nH = $('.navbar').height() || 0,

                wH = $(window).height() - nH,

                sT = $window.scrollTop() + nH,

                sB = sT + wH,

                minH = wH < 600 ? wH : 600,

                platformOffset = platform.offset(),
                pT = platformOffset.top,
                pB = pT + platform.height(),

                mode1 = fullsize ? false : pT > sB,
                mode2 = fullsize ? false : pT < sB && pT > sT && pB > sB,
                mode3 = fullsize ? true : pT <= sT && pB >= sB,
                mode4 = fullsize ? false : pT > sT && pB < sB,
                mode5 = fullsize ? false : pT < sT && pB < sB,
                mode6 = fullsize ? false : pB < sT,

                visible = mode2 || mode3 || mode4 || mode5,

                top = visible ? (function () {

                    if (mode2) return pT;
                    if (mode3) return sT;
                    if (mode4) return pT;
                    if (mode5) return (pB - sT) > minH ? sT : pB - minH;
                })() : 0,

                bot = visible ? (function () {

                    if (mode2) return (sB - pT) > minH ? sB : pT + minH;
                    if (mode3) return sB;
                    if (mode4) return pT + minH;
                    if (mode5) return pB;

                })() : 0,


                outerheight = bot - top,

                availableHeight = outerheight - header.height() - footer.height();

            visible && middle.css({ 'max-height': (outerheight - header.height() - footer.height()) });

            shell.css({ visibility: visible ? 'visible' : 'hidden', top: top, left: platformOffset.left, width: platform.width, 'max-height': outerheight, height: outerheight });

            events.emitter.emit(events.resize, { availableHeight: availableHeight, isPageHeight: fullsize });

            if (false) {

                console.info({ 'max-height': (outerheight - header.height() - footer.height()) });
                console.info({ visibility: visible ? 'visible' : 'hidden', top: top, left: platformOffset.left, width: platform.width, 'max-height': outerheight, height: outerheight });
                console.log({ sT: sT, sB: sB, pT: pT, pB: pB });
                console.log((mode1 ? '1' : '_') + (mode2 ? '2' : '_') + (mode3 ? '3' : '_') + (mode4 ? '4' : '_') + (mode5 ? '5' : '_') + (mode6 ? '6' : '_'));
            }

        }
    },


    makeCompactUpdate: function (_fullsize, header, footer, middle, shell, platform, $window, events) {

        return function () {

            var fullsize = _fullsize(),

                nH = $('.navbar').height() || 0,

                wH = $(window).height() - nH,

                sT = $window.scrollTop() + nH,

                sB = sT + wH,

                minH = wH < 600 ? wH : 600,

                platformOffset = platform.offset(),
                pT = platformOffset.top,
                pB = pT + platform.height(),


                top = fullsize ? sT : pT,

                bot = fullsize ? sB : pB,

                outerheight = bot - top,

                availableHeight = outerheight - header.height() - footer.height(),

                width = $window.width() < 700 ? 700 : $window.width();

            middle.css({ 'max-height': availableHeight });

            shell.css({ visibility: 'visible', top: top, left: platformOffset.left, width: width, 'max-height': outerheight, height: outerheight });

            events.emitter.emit(events.resize, { availableHeight: availableHeight, isPageHeight: fullsize, width: width  });

            if (false) {

                console.info({ visibility: 'visible', top: top, left: platformOffset.left, width: width, 'max-height': outerheight, height: outerheight });
                console.log({ sT: sT, sB: sB, pT: pT, pB: pB });
            }

        }
    },
    makeOnResizeEqualHeight: function (objects) {

        return function (info) {

            var heightUpdate = { 'max-height': info.availableHeight, height: info.availableHeight } // , 'overflow-y': 'scroll'

            isPopulatedArray(objects) && objects.forEach(function (x) { x.css(heightUpdate) });

        }
    },
    makeOnResizeDistribute: function (objects) {

        return function (info) {

            if (isPopulatedArray(objects)) {
                var shared = info.availableHeight / objects.length, heightUpdate = { 'max-height': shared, height: shared }

                objects.forEach(function (x) { x.css(heightUpdate) });
            }

        }
    },
    makeOnResizeDistribute25percent50percent: function (objects) {

        return function (info) {

            if (isPopulatedArray(objects)) {
                var shared25     = info.availableHeight / 4
                 ,  shared50     = info.availableHeight / 2
                 ,  heightUpdate = [{ 'max-height': shared25, height: shared25 }, { 'max-height': shared50, height: shared50 }]

                _.each(objects, function (x, i) { x.css(heightUpdate[i]) });
            }

        }
    },    
    makeHorizontalDistribute: function(fixedObjects, fillObject){

        return function (info) {
            
            var fixedWidths = _.invokeMap(fixedObjects,'width')
              , totalFixed  = _.sum(fixedWidths) + 30
              , remaining   = info.width - totalFixed;

            //console.log('HorizontalDistribute', info.width, fixedWidths, totalFixed, remaining);

            fillObject.css({ width: remaining });
        }
    },
    makeVerticalDistribute: function(fixedObjects, fillObject){

        return function (info) {

            var fixedHeights = _.invokeMap(fixedObjects,'height')
              , totalFixed   = _.sum(fixedHeights) + 30
              , remaining    = info.availableHeight - totalFixed;

            //console.log('VerticalDistribute', info.availableHeight, fixedHeights, totalFixed, remaining);

            fillObject.css({ height: remaining });
        }
    },

    persistenceKeyFromModel: function (model) { return [model.Question.QuestionnaireId, model.Question.QuestionId, model.CallId].join(':') + (model.Item ? (':' + model.Item.ItemId) : '') },
    persistenceKeyFromAnswer: function (answer) { return [answer.QuestionnaireId, answer.QuestionId, answer.CallId].join(':') + (answer.ItemId ? (':' + answer.ItemId) : '') },

    callIdFromPersistenceKey: function (key) { var arrayOfParts = key.split(':'); return isPopulatedArray(arrayOfParts) && arrayOfParts[2] && parseInt(arrayOfParts[2]) },

    format: function () {

        var args = _.tail(arguments);
        return _.head(arguments).replace(/{(\d+)}/g, function (match, number) { return typeof args[number] != 'undefined' ? args[number] : match });
    },

    startBurst: function (callback, times, interval) {

        return function () {

            _.times(times, function (n) { setTimeout(callback, n * interval) })
        }

    },

    timeStamp: function (moment) { return moment().toISOString() },
    
    formattedDate : function(moment){ return function(value, format){ 
        
        return moment(value).format(format);
    
    }  },


    redirectPage            : redirectPage,
    redirectPageWithoutQuery: function(){ redirectPage(getPathFromUrl(window.location.toString())) },

    reloadPage : function() { location.reload() },

    getParameterByName : function(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    },

    getStatusObjFromItem : getStatusObjFromItem,

    setStatus: function (status) { return function (item) { 

            console.error('setStatus', item, status);

            var statusObj = getStatusObjFromItem(item);
            
            if(statusObj){

                statusObj.Value = status;
                item.statusObservable && item.statusObservable(status);
                console.log('modified item:', item);
                return item;
            }
            
        }

    },

    matchesStatus: function (status) { 
        
        var robustStatus = _.upperCase(status.substr(0,4));

        return function (item){

            var statusObj = getStatusObjFromItem(item);
            return statusObj && _.startsWith(_.upperCase(statusObj.Value), robustStatus);
        }
    },

    hashCode : function(str) {
        var hash = 0, i, chr;
        if (str.length === 0) return hash;
        for (i = 0; i < str.length; i++) {
          chr   = str.charCodeAt(i);
          hash  = ((hash << 5) - hash) + chr;
          hash |= 0; // Convert to 32bit integer
        }
        return hash;
    },

    toNbsp: toNbsp,
    unNbsp: unNbsp,

    getBrowserSpecificNonBreakingSpaceCode: getBrowserSpecificNonBreakingSpaceCode
}

module.exports = Helpers;

